import jobCHThumbnail from "assets/websites/jobsCH.jpg";
import pixelartViewerThumbnail from "assets/websites/pixelartViewer.jpg";
import qrCodeGeneratorThumbnail from "assets/websites/qrCodeGenerator.jpg";
import dreamStudiosOverviewThumbnail from "assets/websites/dreamstudiosApp.jpg";
import steamRevenueCalculatorThumbnail from "assets/websites/steamRevenueCalculator.jpg";

export type Website = {
    title: string;
    thumbnail: string;
    description: string;
    url: string;
};

export const websites: Website[] = [
    {
        title: "Job.ch",
        thumbnail: jobCHThumbnail,
        description: "My Dajob - Frontend engineer at Jobcloud AG",
        url: "https://www.jobs.ch/en/"
    },
    {
        title: "Steam revenue calculator",
        thumbnail: steamRevenueCalculatorThumbnail,
        description: "A simple tool to estimate your revenue on Steam based on reviews.",
        url: "https://saturn91.github.io/steamRevenueCalculation/"
    },
    {
        title: "Pixelart CRT viewer",
        thumbnail: pixelartViewerThumbnail,
        description: "A simple page to view pixelart with a CRT post-processing effect.",
        url: "https://saturn91.github.io/pixelartViewer/"
    },
    {
        title: "QR Code Generator",
        thumbnail: qrCodeGeneratorThumbnail,
        description: "A simple tool to generate QR codes.",
        url: "https://saturn91.github.io/QRCodeGenerator/"
    },
    {
        title: "Top Dreamstudios Games",
        thumbnail: dreamStudiosOverviewThumbnail,
        description: "A simple overview of Dream Studios' applications.",
        url: "https://dreamstudios-app-overview.vercel.app/"
    }
];
